import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=bd89b90c&scoped=true"
import script from "./Devices.vue?vue&type=script&lang=ts"
export * from "./Devices.vue?vue&type=script&lang=ts"
import style0 from "./Devices.vue?vue&type=style&index=0&id=bd89b90c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd89b90c",
  null
  
)

export default component.exports